import React, { forwardRef } from "react";
import "./LayeredImage.scss";

const LayeredImage = forwardRef(function LayeredImage(
	{ children, className = "", width, height },
	ref
) {
	let aspectRatio = height / width;
	let padding = aspectRatio * 100;

	return (
		<div
			ref={ref}
			className={`layered-image-wrapper ${className}`}
			style={{
				"--width": `${width}px`,
				"--height": `${height}px`,
			}}
		>
			<div
				className="layered-image"
				style={{
					paddingTop: `${padding}%`,
				}}
			>
				<div className="layered-image-content">{children}</div>
			</div>
		</div>
	);
});

export default LayeredImage;
